import { Modal } from "reactstrap";
import React from "react";

const idleModal = ({ showModal, handleClose, handleLogout, remainingTime }) => {
  return (
    <Modal
      isOpen={showModal}
      size={"xl"}
      onHide={handleClose}
      className="idle-modal"
    >
      <br />
      <br />
    </Modal>
  );
};

export default idleModal;
